import { __spreadArray } from "tslib";
var DeveloperConsole = /** @class */ (function () {
    function DeveloperConsole(prefix, color) {
        this.descriptionof = "This module is a wrapper for \"console.log\". It has an awareness of whether or not it is running in dev mode, so you won't have to deal with annoying console logs in production";
        this.prefix = prefix;
        this.color = color;
    }
    DeveloperConsole.prototype.stylePrefix = function (typeOfLog) {
        if (typeOfLog === void 0) { typeOfLog = 'log'; }
        var styled = ["%c".concat(this.prefix, ": ").concat(typeOfLog)];
        if (!Array.isArray(this.color)) {
            styled.push("background: ".concat(this.color, "; color: white; padding: 2px 0.5em; border-radius: 0.5em;"));
        }
        else {
            styled.push("background: ".concat(this.color[0], "; color: ").concat(this.color[1], "; padding: 2px 0.5em; border-radius: 0.5em;"));
        }
        return styled;
    };
    DeveloperConsole.prototype.log = function () {
        var inputs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            inputs[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.log.apply(console, __spreadArray(__spreadArray([], this.stylePrefix('🪵 log'), false), inputs, false));
        }
    };
    DeveloperConsole.prototype.warning = function () {
        var inputs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            inputs[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.warn.apply(console, __spreadArray(__spreadArray([], this.stylePrefix('🤨 warning'), false), inputs, false));
        }
    };
    DeveloperConsole.prototype.info = function () {
        var inputs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            inputs[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.info.apply(console, __spreadArray(__spreadArray([], this.stylePrefix('🤔 info'), false), inputs, false));
        }
    };
    DeveloperConsole.prototype.error = function () {
        var inputs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            inputs[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.error.apply(console, __spreadArray(__spreadArray([], this.stylePrefix('🙂 error'), false), inputs, false));
        }
    };
    DeveloperConsole.prototype.updateColors = function (color) {
        this.color = color;
    };
    return DeveloperConsole;
}());
export { DeveloperConsole };
